import React from 'react';
import {withTranslations} from '../../HoCs';
import Component from '../../ui-components/Component';
import Page from '../../ui-components/Page';
import HelpFragment from '../../ui-components/Page/components/Help';
import RevenueMigrationWrapper from '../../ui-components/Page/components/RevenueMigrationWrapper';
import { hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import { forceLogout } from '../../services/Network';

class Earn extends Component {
    translation_key = 'earn_translations';
    componentDidMount = () => hmsSelfOnboardingEnabled() && forceLogout();
    render = () => <Page title={this.gc('earning_potential')}>
        <div style={{margin:'10px auto',maxWidth:500,display:'flex',alignItems:'center',padding:'0 10px'}}>
        <RevenueMigrationWrapper/>
        </div>
    </Page>;
    
}

export default withTranslations(Earn);
